import React from 'react';

export default function Dashboard() {
  return (
    <div>
      <h2>Dashboard</h2>
      <p>Your personalized learning path and progress will appear here.</p>
    </div>
  );
}
